import React from 'react';
import { Button } from 'primereact/button';
import { toast } from 'react-toastify';

// Base BscScan URL, you can switch between testnet/mainnet as needed.
const bscScanBaseUrl = "https://bscscan.com/tx/";

const TransactionToast = ({ hash, transactionType }) => {
    const bscScanUrl = `${bscScanBaseUrl}${hash}`;  // Construct BscScan link using the transaction hash

    const copyToClipboard = () => {
        navigator.clipboard.writeText(bscScanUrl)
            .then(() => {
                toast.success("Transaction link copied to clipboard!", {
                    position: "top-right",
                    autoClose: 2000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: false,
                    draggable: false,
                });
            })
            .catch((err) => {
                console.error("Could not copy text: ", err);
                toast.error("Failed to copy transaction link.", {
                    position: "top-right",
                    autoClose: 2000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: false,
                    draggable: false,
                });
            });
    };

    return (
        <div style={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'flex-start',
            alignItems: 'center',
            width: '100%',
        }}>
            <span>{transactionType} Pending.</span>
            <Button
                onClick={copyToClipboard}
                icon="pi pi-copy"
                size="small"
                rounded
                outlined
                style={{ marginLeft: '10px' }}
                aria-label={`Copy ${transactionType} transaction link`}
                severity="secondary"
            />
        </div>
    );
};

export default TransactionToast;
